export default __webpack_public_path__ + "static/figure-gallery-1-reference-4695abaa18cd4bb0893d6454b7251d1e.jpg";